"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ProductAddon;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@sart/styles");
var _client = _interopRequireDefault(require("@sart/client"));
var _content = require("@sart/content");
var _icons = require("@sart/icons");
var _RemoteProductIcon = _interopRequireDefault(require("./RemoteProductIcon"));
var _Text = _interopRequireDefault(require("./Text"));
var _Price = _interopRequireDefault(require("./Price"));
var _moment = _interopRequireDefault(require("moment"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function typeOfProduct(_ref) {
  var localData = _ref.localData,
    localMinutes = _ref.localMinutes,
    localSMS = _ref.localSMS;
  if (localData > 0 && !localMinutes && !localSMS) {
    return 'data';
  }
  if (localMinutes > 0 && !localData && !localSMS) {
    return 'minutes';
  }
  if (localSMS > 0 && !localData && !localMinutes) {
    return 'sms';
  }
  return 'hybrid';
}
var formatDate = function formatDate(date, language) {
  if (date && date !== null) {
    var formatted = (0, _moment["default"])(date).utc().locale(language).format('ddd D MMM');
    var elements = formatted.split('.').join('').split(' ');
    elements[0] = elements[0][0].toUpperCase() + elements[0].slice(1);
    elements[2] = elements[2][0].toUpperCase() + elements[2].slice(1);
    return elements.join(' ');
  }
  return null;
};
function ProductAddon(props) {
  var product = props.product,
    disabled = props.disabled,
    onPress = props.onPress,
    style = props.style,
    placeholderStyle = props.placeholderStyle,
    bodyStyle = props.bodyStyle,
    headerStyle = props.headerStyle,
    titleStyle = props.titleStyle,
    priceStyle = props.priceStyle,
    descriptionStyle = props.descriptionStyle,
    iconColor = props.iconColor;

  /* 
  Functions to get display information from product's Display Details 
  */

  function getDisplayDetailsForLanguage(product) {
    //Get the display details for the language that is selected in the cache
    var displayDetails = undefined;

    //identify the correct display details to use based on language
    if (product.displayDetails) {
      product.displayDetails.map(function (detail) {
        if (detail.language === _client["default"].cache.language) {
          displayDetails = detail;
        }
      });
    }
    return displayDetails;
  }
  function getColourByCategory(displayDetails, category) {
    if (!category) {
      return undefined;
    }
    var toReturn = undefined;
    var hexCodeRegex = /^#(?:[0-9a-fA-F]{3}){1,2}$/;

    //get the relevant font colour based on the category
    if (displayDetails && displayDetails.colors && displayDetails.colors.length) {
      displayDetails.colors.map(function (color) {
        //we also only accept hex values, so use regex to make sure it matches the pattern
        if (color.category === category && hexCodeRegex.test(color.color)) {
          toReturn = color.color;
        } else if (color.category === category && color.color === 'transparent') {
          return undefined;
        }
      });
    }
    return toReturn;
  }
  function getNameTranslation(product) {
    var toReturn = product.productName;
    if (product.displayDetails) {
      product.displayDetails.map(function (detail) {
        if (detail.language === _client["default"].cache.language) {
          toReturn = detail.displayName;
        }
      });
    }
    return toReturn;
  }
  function getDescriptionTranslation(product) {
    var toReturn = product.description;
    if (product.displayDetails) {
      product.displayDetails.map(function (detail) {
        if (detail.language === _client["default"].cache.language) {
          toReturn = detail.displayDescription;
        }
      });
    }
    return toReturn;
  }
  var displayDetails = getDisplayDetailsForLanguage(product);
  // const productImage = getProductIcon(displayDetails)
  var type = typeOfProduct(product);
  var titleColour = getColourByCategory(displayDetails, 'TitleText');
  var descriptionColour = getColourByCategory(displayDetails, 'DescriptiveText');
  var backgroundColour = getColourByCategory(displayDetails, 'Background');
  var name = getNameTranslation(product);
  var description = getDescriptionTranslation(product);
  var content = (0, _content.useContent)();
  var language;
  if (_client["default"].cache.language === 'en') {
    language = 'en-gb';
  } else if (_client["default"].cache.language === 'es') {
    language = 'es-us';
  }
  return /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, {
    style: [styles.container, style, backgroundColour ? {
      backgroundColor: backgroundColour
    } : {}],
    onPress: onPress,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.placeholder, placeholderStyle]
  }, /*#__PURE__*/_react["default"].createElement(_RemoteProductIcon["default"], {
    product: product,
    size: 40,
    webStyle: styles.productImageWeb
  })), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.body, bodyStyle]
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.header, headerStyle]
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [styles.title]
  }, name)), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.header, headerStyle]
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [styles.description, descriptionStyle, descriptionColour ? {
      color: descriptionColour
    } : {}]
  }, description), product.upfrontCost !== undefined && product.upfrontCost > 0 && /*#__PURE__*/_react["default"].createElement(_Price["default"], {
    value: product.upfrontCost,
    style: [styles.price, priceStyle, descriptionColour ? {
      color: descriptionColour
    } : {}],
    code: product.currency
  }), product.upfrontCost === 0 && product.recurringCost !== undefined && product.recurringCost > 0 && /*#__PURE__*/_react["default"].createElement(_Price["default"], {
    value: product.recurringCost,
    style: [styles.price, priceStyle, descriptionColour ? {
      color: descriptionColour
    } : {}],
    code: product.currency
  }), product.upfrontCost === 0 && product.recurringCost === 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [styles.price, priceStyle, descriptionColour ? {
      color: descriptionColour
    } : {}]
  }, content.dashboard.gift)), product.expiration && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [styles.description, descriptionStyle, descriptionColour ? {
      color: descriptionColour
    } : {}]
  }, content.product.expiryShort + ": " + formatDate(product.expiration, language))));
}
ProductAddon.propTypes = {
  product: _propTypes["default"].object,
  onPress: _propTypes["default"].func
};
var styles = _reactNative.StyleSheet.create({
  container: _objectSpread({
    height: 72,
    flexDirection: 'row',
    borderRadius: 8,
    backgroundColor: _styles.backgroundColors.clear,
    elevation: 8
  }, _styles.shadows.shadowByElevation(8)),
  placeholder: {
    // flex: 1,
    width: 72,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: _styles.backgroundColors.exisOrange,
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8
  },
  loadingBackground: {
    // flex: 1,
    width: 72,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8
  },
  body: {
    flex: 1,
    // padding: 12,
    paddingLeft: 12,
    paddingRight: 12
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: _styles.colors.white
  },
  title: _objectSpread(_objectSpread({
    fontSize: 14,
    lineHeight: 24
  }, _styles.typography.lightbold), {}, {
    color: _styles.colors.white,
    paddingTop: 6
  }),
  price: _objectSpread(_objectSpread({
    fontSize: 14,
    lineHeight: 24
  }, _styles.typography.lightbold), {}, {
    color: _styles.colors.white
  }),
  description: _objectSpread({
    fontSize: 14,
    lineHeight: 24,
    color: _styles.colors.white
  }, _styles.typography.medium),
  productImage: {
    // marginTop: 12,
    width: 72,
    // alignItems: 'center',
    // justifyContent: 'center',
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8
  },
  productImageWeb: {
    objectFit: 'contain'
  }
});